import { useNavigate } from 'react-router';
import { mutateConfig } from '../api/mutationConfig';
import { THEMES_KEY, themesUrl, useRefreshThemes, type ProgramThemePayload } from '../api/useProgramThemes';
import { DetailHeader } from '../components/DetailSection';
import { ThemeForm } from '../components/ThemeForm';
import { getErrorMessage } from '../lib/apiError';

export const NewTheme = () => {
  const navigate = useNavigate();
  const refreshThemes = useRefreshThemes();
  const { mutate: createTheme, isPending, error } = mutateConfig()<{ uid: string }>({ url: themesUrl, cacheKeys: [THEMES_KEY] });

  const handleSubmit = (payload: Partial<ProgramThemePayload>) =>
    createTheme(payload, {
      onSuccess: ({ payload: created }) => {
        refreshThemes({ refetch: false });
        navigate(`/themes/${created.uid}`, { state: { notice: `"${payload.name}" created.` } });
      },
    });

  return (
    <div className="flex flex-col gap-6">
      <DetailHeader backTo="/themes" backLabel="Program themes" title="New theme" />
      <p className="text-sm text-gray-500">
        A theme is a named set of pass images and colours. New programs start on the default theme; if there isn't one yet,
        this theme becomes the default.
      </p>
      <ThemeForm
        submitLabel="Create theme"
        isSaving={isPending}
        error={error ? getErrorMessage(error, "Couldn't create the theme. Try again.") : undefined}
        onSubmit={handleSubmit}
      />
    </div>
  );
};
